import React from "react";

export const ProfileButton = () => {
  
  return (
    <a role={"button"} href="/profile" className="btn btn-link" style={{textDecoration: "none"}}>Profile</a>
    
  );
};